import React from 'react';

/**
 * Public route wrapper
 * Accessible to all users (authenticated or not)
 */
function PublicRoutes({ children }) {
    return children;
}

export default PublicRoutes;
